<mat-card  appearance="outlined"  *ngIf="processing">
  <span>Loading</span><br />
  <mat-progress-bar mode="query"></mat-progress-bar>
</mat-card>

<mat-card appearance="outlined" *ngIf="!processing">
  <mat-card-title> <mat-icon class="icon-20" >person</mat-icon> {{user?.fullName}} ({{user?.userName}})</mat-card-title>
    <div class="flex flex-row flex-wrap gap-2">
      <div class="w-full">       
        <span>&nbsp;</span>
      </div>

      <div class="flex-1 min-w-[50%] sm:min-w-full" *ngIf="user?.email != null && user?.email.length > 0">   
        <em class="text-muted">Email:  &nbsp;&nbsp;</em>     
        <span>{{user?.email}}</span>
      </div>

      <div class="flex-1 min-w-[50%] sm:min-w-full" *ngIf="user?.address != null && user?.address.length > 0">   
        <em class="text-muted">Address:  &nbsp;&nbsp;</em>     
        <span>{{user?.address}} {{user?.city}} {{user?.state}} {{user?.zip}}</span>
      </div>

      <div class="flex-1 min-w-[50%] sm:min-w-full" *ngIf="user?.mobile != null && user?.mobile.length > 0">   
        <em class="text-muted">Mobile:  &nbsp;&nbsp;</em>     
        <span>{{user?.mobile}}</span>
      </div>

      <div class="flex-1 min-w-[50%] sm:min-w-full"  *ngIf="user?.phone != null && user?.phone.length > 0">   
        <em class="text-muted">Phone:  &nbsp;&nbsp;</em>     
        <span>{{user?.phone}}</span>
      </div>
      
      <div class="flex-1 min-w-[50%] sm:min-w-full"  *ngIf="user?.jobTitle != null && user?.jobTitle.length > 0">   
        <em class="text-muted">Title:  &nbsp;&nbsp;</em>     
        <span>{{user?.jobTitle}}</span>
      </div>

      <div class="flex-1 min-w-[50%] sm:min-w-full" *ngIf="user?.roles != null && user?.roles.length > 0">   
        <em class="text-muted">Roles:  &nbsp;&nbsp;</em> 
        <ul>
          <li *ngFor="let role of user?.roles">{{role}}</li>
        </ul>    
      </div>

      
   
    </div>
</mat-card>
